import { ROUTE_PERMISSIONS, AppRoutePath } from './permissions';
import { PERMISSION_GROUPS, getModule, isValidPermKey, parsePermKey } from './permissionModules';

/**
 * Tên màn hình hiển thị cho admin trên màn Nhóm quyền ("quyền này mở màn nào",
 * "nhóm này vào được những màn nào"). Kiểu Record bắt buộc mọi route đều có tên.
 */
export const ROUTE_TITLES: Record<AppRoutePath, string> = {
  '/unauthorized': 'Không có quyền truy cập',
  '/realtime-demo': 'Thử nghiệm Realtime',
  '/notifications': 'Thông báo',
  '/': 'Trang chủ',

  // CMS / nghiệp vụ
  '/chats': 'Chats',
  '/chat/:id': 'Phòng chat',
  '/customer': 'Danh sách khách hàng',
  '/customer/:id': 'Chi tiết khách hàng',
  '/appointments': 'Lịch hẹn',
  '/appointment/create': 'Tạo lịch hẹn',
  '/appointment/detail/:id': 'Chi tiết lịch hẹn',
  '/appointment/:id': 'Chi tiết lịch hẹn (cũ)',
  '/consultations': 'Lịch tư vấn',
  '/consultation/detail/:id': 'Chi tiết lịch tư vấn',
  '/execution-schedule': 'Lịch thực hiện',
  '/execution-schedule/detail/:id': 'Chi tiết lịch thực hiện',
  '/list-order': 'Danh sách bán hàng',
  '/order-detail': 'Chi tiết đơn hàng',

  // Chuyên môn
  '/hair-clinic': 'Phiếu cấy tóc',
  '/miko-reception': 'Phiếu tiếp nhận Miko',
  '/cosmetic-surgery-reception': 'Phiếu phẫu thuật',
  '/thread-lift-reception': 'Phiếu căng chỉ',
  '/consultation-form': 'Phiếu Ozempic',
  '/beauty-consultation': 'Phiếu tư vấn (mặt)',
  '/consultation-tabs': 'Phiếu tư vấn da',

  // Danh mục
  '/customer-tags': 'Thẻ sale',
  '/appointment-transitions': 'Ma trận trạng thái',
  '/care-status': 'Thẻ chat',
  '/profession': 'Ngành nghề',
  '/quick-messages': 'Tin nhắn nhanh',

  // Nhân viên
  '/employee': 'Nhân viên',
  '/group-roles': 'Nhóm quyền',
  '/departments': 'Phòng ban',

  // Dịch vụ & Sản phẩm
  '/services': 'Danh mục dịch vụ',
  '/services-list': 'Dịch vụ',
  '/products-cat': 'Danh mục sản phẩm',
  '/products': 'Sản phẩm',

  // Khác
  '/advertise': 'Quảng cáo',
  '/advertise/detail': 'Chi tiết quảng cáo',
  '/branch-manager': 'Chi nhánh',

  // Báo cáo
  '/overview-report': 'Báo cáo tổng quan',
  '/page-report': 'Báo cáo trang',
  '/sale-online-report': 'Báo cáo Sale Online',
  '/customer-report': 'Báo cáo khách hàng',
  '/business-report': 'Báo cáo kinh doanh',
  '/dashbroad-truc-page': 'Dashboard kinh doanh',

  // POS
  '/pos': 'Bán hàng tại quầy',
  '/pos/orders': 'Đơn hàng POS',
  '/pos/drafts': 'Đơn nháp POS',
  '/pos/transactions': 'Giao dịch POS',
  '/pos/refunds': 'Hoàn tiền POS',
  '/pos/promotions': 'Khuyến mãi POS',
  '/pos/import': 'Import MySpa',
  '/pos/dashboard': 'Thống kê POS',
  '/pos/dispatch': 'Điều phối phòng',

  // Thẻ liệu trình
  '/treatment': 'Tổng quan thẻ liệu trình',
  '/treatment/cards': 'Thẻ liệu trình',
  '/treatment/checkin': 'Trừ buổi liệu trình',
  '/treatment/debts': 'Công nợ thẻ liệu trình',
  '/treatment/packages': 'Gói liệu trình',

  // Tài liệu
  '/personal-documents': 'Tài liệu cá nhân',
  '/personal-documents/detail': 'Chi tiết tài liệu',
  '/document-dashboard': 'Tổng quan tài liệu',
  '/document-management': 'Quản lý tài liệu',
  '/add-new-document': 'Tạo tài liệu',
  '/document-approval': 'Duyệt tài liệu',
  '/document-trash': 'Thùng rác tài liệu',
  '/document-type': 'Loại tài liệu',
  '/list-of-documents': 'Danh mục tài liệu',

  // Cá nhân
  '/admin/profile': 'Thông tin cá nhân',
  '/check-in': 'Check-in',

  // CSKH
  '/care-list': 'Lịch chăm sóc khách hàng',
  '/customer-demo': 'Tổng đài (Call center)',
  '/customer-demo/detail': 'Chi tiết cuộc gọi',
  '/cskh-dashboard': 'Tổng quan CSKH',
  '/cskh-tasks': 'Công việc CSKH',
  '/cskh-complaints': 'Khiếu nại',
  '/cskh-surveys': 'Khảo sát hài lòng',

  // Marketing
  '/marketing-report': 'Báo cáo Marketing',
  '/bao-cao-cco': 'Báo cáo CCO',
  '/marketing-campaign-report': 'Báo cáo hiệu suất chiến dịch',
  '/advertising-campaign': 'Chiến dịch quảng cáo',
  '/advertising-campaign-management': 'Quản lý tiền tố chiến dịch',

  // Phòng mổ & ê-kíp
  '/or-schedule': 'Lên lịch mổ',
  '/operating-room': 'Phòng mổ',
  '/implementation-schedule': 'Lịch trình triển khai',
  '/assign': 'Điều động ê-kíp & phân công',

  // Workplace
  '/social': 'Mạng nội bộ',
  '/work-report': 'Báo cáo công việc',
  '/work-list': 'Danh sách công việc',
  '/work-calender': 'Lịch làm việc / cuộc họp',
  '/projects': 'Danh sách dự án',
  '/projects/detail': 'Chi tiết dự án',
  '/projects/add': 'Thêm dự án',
  '/projects/setup': 'Cài đặt dự án',
  '/request': 'Quy trình trình ký',
  '/request/add': 'Tạo yêu cầu trình ký',
  '/submit-for-signature': 'Quản lý trình ký',
  '/submit-for-signature/add': 'Tạo quy trình mẫu',
  '/digital-signature': 'Danh sách ký số',
  '/digital-signature/detail': 'Chi tiết ký số',
  '/assets': 'Tổng quan tài sản',
  '/assets/list': 'Danh sách tài sản',
  '/assets/detail': 'Chi tiết tài sản',
  '/assets/allocation': 'Danh sách cấp phát',
  '/assets/allocation-detail': 'Chi tiết cấp phát',
  '/assets/recall': 'Danh sách thu hồi',
  '/assets/recall-detail': 'Chi tiết thu hồi',
  '/assets/add': 'Thêm tài sản',
  '/assets/allocation-add': 'Tạo phiếu cấp phát',
  '/assets/add-new-recall': 'Tạo phiếu thu hồi',
  '/assets/edit': 'Sửa phiếu cấp phát',
  '/assets/recall-edit': 'Sửa phiếu thu hồi',
  '/assets/setup': 'Cài đặt tài sản',
  '/so-do-to-chuc': 'Sơ đồ tổ chức',
  '/tien-trinh': 'Tiến trình',
  '/work-process-page': 'Quá trình làm việc',

  // HRM
  '/personnel-management': 'Hồ sơ nhân sự',
  '/personnel-management/dashbroad': 'Tổng quan nhân sự',
  '/personnel-management/detail': 'Chi tiết nhân sự',
  '/personnel-management/add': 'Thêm nhân sự',
  '/probation': 'Thử việc',
  '/offboarding': 'Nghỉ việc',
  '/headcount-plan': 'Định biên nhân sự',
  '/employment-contract': 'Hợp đồng lao động',
  '/employment-contract/detail': 'Chi tiết hợp đồng lao động',
  '/employment-contract/add': 'Thêm hợp đồng lao động',
  '/decision': 'Danh sách quyết định',
  '/decision/detail': 'Chi tiết quyết định',
  '/contract-management': 'Quản lý hợp đồng nhân viên',
  '/career-progression': 'Lộ trình thăng tiến',
  '/recruitment': 'Tổng quan tuyển dụng',
  '/candidates-view': 'Ứng viên',
  '/candidate-detail/detail': 'Chi tiết ứng viên',
  '/jobs-view': 'Yêu cầu tuyển dụng',
  '/interviews': 'Lịch phỏng vấn',
  '/offers': 'Offer & nhận việc',
  '/talent-pool': 'Kho ứng viên',
  '/job/detail': 'Chi tiết yêu cầu tuyển dụng',
  '/candidate/add': 'Thêm ứng viên',
  '/job/add': 'Tạo yêu cầu tuyển dụng',
  '/timesheet': 'Bảng chấm công',
  '/timekeeping': 'Tổng quan chấm công',
  '/time-requests': 'Đơn từ',
  '/leave-balance': 'Phép năm',
  '/shifts': 'Ca làm việc',
  '/furlough': 'Bảng phép',
  '/furlough/add': 'Tạo đơn xin nghỉ',
  '/task-assignment': 'Phân ca',
  '/timekeeping-reports': 'Báo cáo chấm công',
  '/timekeeping-reports/bao-cao-don-xin-nghi': 'Báo cáo đơn xin nghỉ',
  '/timekeeping-reports/bao-cao-di-muon': 'Báo cáo đi muộn',
  '/timekeeping-reports/bao-cao-tong-hop': 'Báo cáo chấm công tổng hợp',
  '/salary': 'Bảng lương',
  '/salary/dashboard': 'Tổng quan lương',
  '/pit': 'Thuế TNCN',
  '/salary-advances': 'Tạm ứng & điều chỉnh lương',
  '/payslips': 'Phiếu lương',
  '/payroll-settings': 'Thiết lập lương',

  // Kế toán
  '/ke-toan': 'Tổng quan kế toán',
  '/ke-toan/bills': 'Duyệt khóa sổ doanh thu',
  '/ke-toan/reconcile': 'Đối soát',
  '/ke-toan/invoices': 'Hóa đơn đầu ra',
  '/ke-toan/tax-rates': 'Thuế suất và bảng giá',
  '/ke-toan/tax-return': 'Kê khai thuế GTGT',
  '/ke-toan/books': 'Sổ Thuế và Sổ Quản trị',
  '/ke-toan/cards': 'Thẻ liệu trình và nhật ký trừ thẻ',
  '/ke-toan/deposits': 'Cọc và công nợ',
  '/ke-toan/refunds': 'Duyệt hủy thẻ, hoàn tiền',
  '/ke-toan/commission': 'Hoa hồng và tua ekip',
  '/ke-toan/counter': 'Đối soát POS',
  '/ke-toan/counter-bills': 'Bill trong ngày',
  '/ke-toan/shift-review': 'Nhận biên bản ca',
  '/ke-toan/shift': 'Chốt ca và bảng kê',
  '/ke-toan/sessions': 'Ghi ca thực hiện',

  // Kho hàng
  '/warehouse-dashboard': 'Tổng quan kho',
  '/warehouses': 'Tồn kho',
  '/warehouses/detail': 'Thẻ kho mặt hàng',
  '/warehouse-items': 'Danh mục vật tư',
  '/service-norms': 'Định mức vật tư dịch vụ',
  '/inventory-count': 'Kiểm kho',
  '/supplier': 'Nhà cung cấp',
  '/supplier/detail': 'Chi tiết nhà cung cấp',
  '/supplier/add': 'Thêm nhà cung cấp',
  '/sales-contract': 'Hợp đồng mua',
  '/sales-contract/detail': 'Chi tiết hợp đồng mua',
  '/sales-contract/add': 'Thêm hợp đồng mua',
  '/purchase-order': 'Đơn hàng mua',
  '/purchase-order/detail': 'Chi tiết đơn hàng mua',
  '/purchase-order/add': 'Thêm đơn hàng mua',
  '/import-export': 'Phiếu kho',
  '/import-export/detail': 'Chi tiết phiếu kho',
  '/import-export/add-import': 'Lập phiếu nhập mua',
  '/import-export/add-export': 'Lập phiếu xuất / chuyển / hủy',
  '/import-export/create-inventory-count': 'Lập phiếu kiểm kho',
  '/inventory': 'Báo cáo xuất nhập tồn',
  '/inventory/detail': 'Chi tiết xuất kho',
  '/report-list': 'Báo cáo kho',

  // Tài chính
  '/revenue': 'Phiếu thu',
  '/expense': 'Phiếu chi',
  '/expense-detail/detail': 'Chi tiết phiếu chi',
  '/expense/add': 'Tạo phiếu chi',
  '/budget': 'Ngân sách',
  '/bank-list': 'Tài khoản ngân hàng',
  '/debt': 'Công nợ',
  '/debt-detail/detail': 'Chi tiết công nợ',
  '/debt-contract/detail': 'Chi tiết hợp đồng vay nợ',

  // Telesales
  '/telesales/appointments': 'Lịch hẹn',
  '/telesales/consultations': 'Lịch tư vấn',
  '/telesales/chats': 'Chat',
  '/telesales/reassign-history': 'Lịch sử chia lại khách',
  '/telesales/deposits': 'Đối soát cọc',
  '/telesales/settings': 'Cài đặt Telesale',
  // Khách tự điền trên kiosk / iPad sau check-in
  '/khai-bao': 'Khai báo thông tin khách',
};

/** Route hệ thống, không liệt kê khi xem phạm vi truy cập. /khai-bao là form khách tự điền ở kiosk, không phải màn của nhân viên. */
const SYSTEM_ROUTES: string[] = ['/unauthorized', '/realtime-demo', '/khai-bao'];

const ROUTE_ENTRIES = Object.entries(ROUTE_PERMISSIONS) as [AppRoutePath, string][];

/** Tên các màn hình mà 1 permission key mở được (vd 'salary.view' -> Bảng lương, Tổng quan lương, Thuế TNCN). */
export function getScreensForPermission(permKey: string): string[] {
  const titles = ROUTE_ENTRIES.filter(([, perm]) => perm === permKey).map(([path]) => ROUTE_TITLES[path]);
  return Array.from(new Set(titles));
}

export interface ScreenAccessSection {
  /** Nhóm module (Workplace, HRM...) hoặc "Cá nhân" cho màn chỉ cần đăng nhập */
  group: string;
  modules: { module: string; screens: string[] }[];
}

/**
 * Các màn hình 1 bộ quyền vào được, gom theo nhóm module rồi theo module,
 * theo đúng thứ tự hiển thị trên màn Nhóm quyền.
 */
export function getAccessibleScreens(permissions: string[]): ScreenAccessSection[] {
  const granted = new Set(permissions);
  const byModule = new Map<string, Set<string>>();
  const personal = new Set<string>();

  for (const [path, perm] of ROUTE_ENTRIES) {
    if (SYSTEM_ROUTES.includes(path)) continue;
    if (perm === '') { personal.add(ROUTE_TITLES[path]); continue; }
    if (!granted.has(perm) || !isValidPermKey(perm)) continue;
    const moduleKey = parsePermKey(perm)!.moduleKey;
    if (!byModule.has(moduleKey)) byModule.set(moduleKey, new Set());
    byModule.get(moduleKey)!.add(ROUTE_TITLES[path]);
  }

  const sections: ScreenAccessSection[] = PERMISSION_GROUPS.map((g) => ({
    group: g.label,
    modules: g.moduleKeys
      .filter((mk) => byModule.has(mk))
      .map((mk) => ({ module: getModule(mk)!.label, screens: Array.from(byModule.get(mk)!) })),
  })).filter((s) => s.modules.length > 0);

  sections.push({ group: 'Cá nhân', modules: [{ module: 'Chỉ cần đăng nhập', screens: Array.from(personal) }] });
  return sections;
}
